var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolfun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 351.17 159.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231815;\n      }\n\n      .cls-2 {\n        fill: #21b04b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.46,106.1c-20.13,0-36.5-16.37-36.5-36.5s16.37-36.5,36.5-36.5,36.5,16.37,36.5,36.5-16.37,36.5-36.5,36.5Zm0-53c-9.1,0-16.5,7.4-16.5,16.5s7.4,16.5,16.5,16.5,16.5-7.4,16.5-16.5-7.4-16.5-16.5-16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.6,69.6c0-20.13-16.37-36.5-36.5-36.5S1.59,49.47,1.59,69.6s15.52,35.62,34.91,36.46v.04c9.1,0,16.5,7.4,16.5,16.5s-7.4,16.5-16.5,16.5-16.5-7.4-16.5-16.5H0c0,20.13,16.37,36.5,36.5,36.5s36.5-16.37,36.5-36.5c0-10.04-4.08-19.15-10.66-25.75,7.51-6.69,12.25-16.43,12.25-27.25Zm-53,0c0-9.1,7.4-16.5,16.5-16.5s16.5,7.4,16.5,16.5-7.4,16.5-16.5,16.5-16.5-7.4-16.5-16.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 162.65,
    y: 25.45,
    width: 20,
    height: 80.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m314.67,32.47c-20.13,0-36.5,16.37-36.5,36.5h0c0,9.1-7.4,16.5-16.5,16.5s-16.5-7.4-16.5-16.5h-20c0,20.13,16.37,36.5,36.5,36.5s36.5-16.37,36.5-36.5h0c0-9.1,7.4-16.5,16.5-16.5s16.5,7.4,16.5,16.5v36.5h20v-36.5c0-20.13-16.37-36.5-36.5-36.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 249.47,
    y: 38.05,
    width: 9.23,
    height: 14.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 262.72,
    y: 38.05,
    width: 9.23,
    height: 14.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m227.88,20V0c-20.13,0-35.05,16.37-35.05,36.5,0,.27,0,.53.02.8v68.17h20v-48.97h15.03v-20h-15.05c0-9.1,5.95-16.5,15.05-16.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfun);
export default __webpack_public_path__ + "static/media/golfun.f3241f7023d25842d40c579afd848a97.svg";
export { ForwardRef as ReactComponent };